import { Just, get } from 'pratica';

// action types
export const actionTypes = {
  REVIEW_SUMMARY_FETCH_FULFILLED: 'zola/cards/project/customization/REVIEW_SUMMARY_FETCH_FULFILLED',
  CUSTOM_NOTES_FETCH_FULFILLED: 'zola/cards/project/customization/CUSTOM_NOTES_FETCH_FULFILLED',
  CUSTOM_NOTES_FETCH_REJECTED: 'zola/cards/project/customization/CUSTOM_NOTES_FETCH_REJECTED',
  SET_PENDING_CHANGES: 'zola/cards/project/customization/SET_PENDING_CHANGES',
};

// action creators
const getProject = uuid => fetch(`/web-api/v2/card-project/${uuid}`).then(res => res.json());

const getProjectMeta = uuid =>
  fetch(`/web-api/v2/card-project/${uuid}/meta`).then(res => res.json());

const getCustomNotes = uuid =>
  fetch(`/web-api/v2/card-project/guestdata/project/${uuid}`).then(res => res.json());

const reviewSummaryFulfilled = payload => ({
  type: actionTypes.REVIEW_SUMMARY_FETCH_FULFILLED,
  payload,
});

const customNotesFulfilled = payload => ({
  type: actionTypes.CUSTOM_NOTES_FETCH_FULFILLED,
  payload,
});

const customNotesRejected = () => ({ type: actionTypes.CUSTOM_NOTES_FETCH_REJECTED });

export const fetchReviewSummary = () => (dispatch, getState) =>
  Just(getState())
    .chain(get(['cards', 'project', 'uuid']))
    .cata({
      Just: uuid =>
        Promise.all([getProject(uuid), getProjectMeta(uuid)])
          .then(data => dispatch(reviewSummaryFulfilled(data)))
          .catch(),
      Nothing: () => Promise.reject(),
    });

export const fetchCustomNotes = () => (dispatch, getState) =>
  Just(getState())
    .chain(get(['cards', 'project', 'uuid']))
    .cata({
      Just: uuid =>
        getCustomNotes(uuid)
          .then(data => dispatch(customNotesFulfilled(data)))
          .catch(() => dispatch(customNotesRejected())),
      Nothing: () => null,
    });

export const setPendingChanges = value => ({
  type: actionTypes.SET_PENDING_CHANGES,
  payload: value,
});



// WEBPACK FOOTER //
// ./src/cards/reducers/customization/actions.js